import React, { useEffect, useState } from "react";
import api, { brl, fmtDate } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { CreditCard, FileDown, ExternalLink, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { PagamentoPix } from "@/components/PagamentoPix";

const STATUS = { ativo: ["Em dia", "bg-emerald-100 text-emerald-700"], pendente: ["Vencida", "bg-amber-100 text-amber-700"], inadimplente: ["Inadimplente", "bg-red-100 text-red-700"], suspenso: ["Suspensa", "bg-red-100 text-red-700"], cancelado: ["Cancelada", "bg-slate-200 text-slate-600"] };

export const openReceipt = async (eid, hid) => {
  try {
    const r = await api.get(`/empresas/${eid}/cobranca/recibo/${hid}`, { responseType: "blob" });
    window.open(URL.createObjectURL(r.data), "_blank");
  } catch { toast.error("Não foi possível gerar o recibo"); }
};

export const MinhaAssinatura = ({ empresaId }) => {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/minha-assinatura").then((r) => setD(r.data)).catch(() => setD({ erro: true })); }, []);
  if (!d) return <Loader2 className="w-5 h-5 animate-spin gold-text" />;
  if (d.erro) return <p className="text-sm text-slate-500">Não foi possível carregar sua assinatura.</p>;
  const [lbl, cls] = STATUS[d.status] || STATUS.ativo;
  return (
    <div className="space-y-4" data-testid="minha-assinatura">
      <h3 className="font-bold flex items-center gap-2"><CreditCard className="w-5 h-5 gold-text" /> Assinatura da plataforma</h3>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 text-sm">
        <div className="rounded-lg bg-slate-50 p-3 min-w-0"><div className="text-xs text-slate-500">Plano</div><div className="font-bold truncate" data-testid="assinatura-plano">{d.plano || "—"}</div></div>
        <div className="rounded-lg bg-slate-50 p-3 min-w-0"><div className="text-xs text-slate-500">Mensalidade</div><div className="font-bold mono num-nowrap" data-testid="assinatura-valor">{brl(d.valor_mensalidade)}</div></div>
        <div className="rounded-lg bg-slate-50 p-3 min-w-0"><div className="text-xs text-slate-500">Vencimento</div><div className="font-bold mono num-nowrap" data-testid="assinatura-venc">{fmtDate(d.proximo_vencimento)}</div></div>
        <div className="rounded-lg bg-slate-50 p-3 min-w-0"><div className="text-xs text-slate-500">Situação</div><Badge className={cls} data-testid="assinatura-status">{lbl}</Badge></div>
      </div>
      {d.link_pagamento && (
        <a href={d.link_pagamento} target="_blank" rel="noreferrer"><Button className="bg-[#635BFF] hover:bg-[#5147e5] text-white gap-2 w-full lg:w-auto" data-testid="assinatura-pagar-btn"><ExternalLink className="w-4 h-4" /> Pagar mensalidade online</Button></a>
      )}
      <PagamentoPix onChange={() => api.get("/minha-assinatura").then((r) => setD(r.data))} />
      <div>
        <div className="text-sm font-semibold mb-2">Pagamentos e recibos</div>
        {d.historico.length === 0 ? <p className="text-sm text-slate-500">Nenhum pagamento registrado ainda.</p> : (
          <ul className="divide-y rounded-lg border text-sm" data-testid="assinatura-historico">
            {d.historico.map((h) => (
              <li key={h.id} className="flex items-center justify-between gap-2 px-3 py-2 flex-wrap" data-testid={`assinatura-pgto-${h.id}`}>
                <div className="min-w-0"><div className="font-semibold mono num-nowrap">{brl(h.valor)}</div><div className="text-xs text-slate-500 num-nowrap">{fmtDate(h.data)} • válido até {fmtDate(h.periodo_ate)}{h.registrado_por === "Stripe" && " • Stripe"}</div></div>
                <Button size="sm" variant="outline" className="gap-1" onClick={() => openReceipt(empresaId, h.id)} data-testid={`assinatura-recibo-${h.id}`}><FileDown className="w-4 h-4" /> Recibo</Button>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};
